import React from 'react';
import { Unity, useUnityContext } from 'react-unity-webgl';
import './App.css';

function App() {
  const {
    unityProvider,
    isLoaded,
    loadingProgression
  } = useUnityContext({
    loaderUrl: "./unityBuild/WebGL.loader.js",
    dataUrl: "./unityBuild/WebGL.data",
    frameworkUrl: "./unityBuild/WebGL.framework.js",
    codeUrl: "./unityBuild/WebGL.wasm",
    webglContextAttributes: {
      preserveDrawingBuffer: true,
    },
  });

  return (
    <div className="App">
    {!isLoaded && (
      <div classname="LoadingContainer">
        <div className="LoadingText">Загружается...</div>
        <div className="LoadingBar">
          <div
            className="LoadingBarFill"
            style={{ width: loadingProgression * 398 }}
          />
        </div>
      </div>
    )}
    <Unity
        unityProvider={unityProvider}
        style={{
          display: isLoaded ? "block" : "none",
          width: "100vw",
          height: "100vh",
          overflow: "hidden",
          zIndex: 0 }}
    />
    </div>
  );
}

export default App;
